import { render } from "./unbrick-ch341a.md?vue&type=template&id=11174ca6"
import script from "./unbrick-ch341a.md?vue&type=script&lang=js"
export * from "./unbrick-ch341a.md?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__